import { supabase } from '../lib/supabase'
import type { CalendarEvent } from '../types/index'

function rowToEvent(r: Record<string, unknown>): CalendarEvent {
  return {
    id:           r.id as string,
    title:        r.title as string,
    date:         r.date as string,
    time:         r.time as string | undefined,
    type:         (r.type as CalendarEvent['type']) || 'meeting',
    clientId:     r.client_id as string | undefined,
    clientName:   r.client_name as string | undefined,
    description:  r.description as string | undefined,
    googleEventId: r.google_event_id as string | undefined,
    source:       (r.source as CalendarEvent['source']) || 'erp',
  }
}

export async function getCalendarEvents(): Promise<CalendarEvent[]> {
  const { data, error } = await supabase
    .from('calendar_events')
    .select('*')
    .order('date', { ascending: true })
  if (error) throw error
  return (data ?? []).map(rowToEvent)
}

export async function createCalendarEvent(e: Omit<CalendarEvent, 'id'>): Promise<CalendarEvent> {
  const { data, error } = await supabase.from('calendar_events').insert({
    title: e.title, date: e.date, time: e.time, type: e.type,
    client_id: e.clientId || null, client_name: e.clientName,
    description: e.description, google_event_id: e.googleEventId, source: e.source || 'erp',
  }).select().single()
  if (error) throw error
  return rowToEvent(data)
}

export async function updateCalendarEvent(id: string, e: Partial<CalendarEvent>): Promise<void> {
  const updates: Record<string, unknown> = {}
  if (e.title        !== undefined) updates.title          = e.title
  if (e.date         !== undefined) updates.date           = e.date
  if (e.time         !== undefined) updates.time           = e.time
  if (e.type         !== undefined) updates.type           = e.type
  if (e.clientId     !== undefined) updates.client_id      = e.clientId || null
  if (e.clientName   !== undefined) updates.client_name    = e.clientName
  if (e.description  !== undefined) updates.description    = e.description
  if (e.googleEventId !== undefined) updates.google_event_id = e.googleEventId
  const { error } = await supabase.from('calendar_events').update(updates).eq('id', id)
  if (error) throw error
}

export async function deleteCalendarEvent(id: string): Promise<void> {
  const { error } = await supabase.from('calendar_events').delete().eq('id', id)
  if (error) throw error
}
